var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStripe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10995",
    "data-name": "Group 10995",
    transform: "translate(-123 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8656",
    "data-name": "Rectangle 8656",
    transform: "translate(123 398)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.25)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 41,
    height: 41,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stripe_Logo__revised_2016",
    "data-name": "Stripe_Logo,_revised_2016",
    transform: "translate(75.028 376.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10004",
    "data-name": "Path 10004",
    d: "M345.88,71.41c0-2.129-1.031-3.81-3-3.81s-3.177,1.68-3.177,3.793c0,2.5,1.414,3.768,3.444,3.768a4.638,4.638,0,0,0,2.3-.541V72.957a4.417,4.417,0,0,1-2.038.457c-.807,0-1.522-.283-1.614-1.264h4.068C345.864,72.042,345.88,71.609,345.88,71.41Zm-4.109-.79c0-.94.574-1.331,1.1-1.331.507,0,1.048.391,1.048,1.331Z",
    transform: "translate(-261.935 -28.971)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10005",
    "data-name": "Path 10005",
    d: "M261.768,67.6a2.35,2.35,0,0,0-1.63.649l-.108-.516H258.2v9.7l2.08-.441.008-2.354a2.342,2.342,0,0,0,1.472.524c1.489,0,2.845-1.2,2.845-3.835C264.6,68.914,263.224,67.6,261.768,67.6Zm-.5,5.731a1.243,1.243,0,0,1-.982-.391l-.008-3.086a1.238,1.238,0,0,1,.99-.408c.757,0,1.281.848,1.281,1.938C262.55,72.5,262.035,73.331,261.269,73.331Z",
    transform: "translate(-187.215 -28.971)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10006",
    "data-name": "Path 10006",
    d: "M223.8,38.138l2.088-.449V36l-2.088.441Z",
    transform: "translate(-155.676)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8626",
    "data-name": "Rectangle 8626",
    width: 2.088,
    height: 7.278,
    transform: "translate(68.124 38.77)",
    fill: "#635bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10007",
    "data-name": "Path 10007",
    d: "M175.63,68.968l-.133-.616h-1.8v7.278h2.08V70.7a1.467,1.467,0,0,1,1.58-.433V68.352A1.412,1.412,0,0,0,175.63,68.968Z",
    transform: "translate(-109.743 -29.582)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10008",
    "data-name": "Path 10008",
    d: "M124.438,47.6l-2.03.433L122.4,54.7a2.09,2.09,0,0,0,2.154,2.138,3.213,3.213,0,0,0,1.456-.274V54.87c-.266.108-1.58.491-1.58-.74V51.177h1.58V49.405h-1.58Z",
    transform: "translate(-62.71 -10.635)",
    fill: "#635bff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10009",
    "data-name": "Path 10009",
    d: "M56.1,69.854c0-.324.266-.449.707-.449a4.64,4.64,0,0,1,2.063.532V67.983a5.486,5.486,0,0,0-2.063-.383c-1.689,0-2.812.882-2.812,2.354,0,2.3,3.161,1.93,3.161,2.92,0,.383-.333.507-.8.507a5.178,5.178,0,0,1-2.271-.665V74.7a5.766,5.766,0,0,0,2.271.474c1.73,0,2.92-.857,2.92-2.346C59.274,70.345,56.1,70.786,56.1,69.854Z",
    transform: "translate(0 -28.971)",
    fill: "#635bff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.67998bf8b111e67f9cc74648afa50f8c.svg";
export { ForwardRef as ReactComponent };